{
    "raporgunlukisler": {
        "Baslik": "Dagelijkse Taken Rapport",
        "Tarih": "Datum",
        "Kullanici": "Gebruiker",
        "Aciklama": "Bestand / Proces Beschrijving",
        "Saat": "Tijd",
        "Arama": "Zoeken",
        "Ara": "Zoek",
        "Kapat": "Sluiten",
        "Temizle": "Wissen",
        "BaslangicTarihi": "Startdatum",
        "BitisTarihi": "Einddatum",
        "BaslamaSaat": "Starttijd",
        "BitisSaat": "Eindtijd",
        "Islemler": "Acties",
        "Duzenle": "Bewerken",
        "Sil": "Verwijderen",
        "Guncelle": "Bijwerken",
        "EminMisiniz": "Weet u het zeker?",
        "GeriAlamazsiniz": "U kunt dit niet ongedaan maken!",
        "EvetSil": "Ja, verwijder het!",
        "Iptal": "Annuleren",
        "GoruntuleTooltip": "Bekijken",
        "SilTooltip": "Verwijderen",
        "Kapsam": "Bereik",
        "Takim": "Team",
        "Sube": "Filiaal",
        "Kendi": "Eigen",
        "Tam": "Volledig"
    }
}
